// extracted by mini-css-extract-plugin
module.exports = {"inputChipsField":"InputChipsField_inputChipsField__18vpj","label":"InputChipsField_label__1WRPn","input":"InputChipsField_input__JaWN-"};